module.exports = __webpack_public_path__ + "static/media/dragon-egg.0da62b31.png";